export default {
  heading: "#027F00",
  folder_color: "#FBDB64",
  muted: "#EBEBEB",
};
